import { getWorkspaces } from "../apis/workspace/invitations";
import { useStoreWorkspaces } from "../stores/useStoreWorkspaces";
import { useSmartQuery } from "./useSmartQuery";

export const useWorkspaces = (isVerified) => {
  const { pendingInvitations, membershipRequests, workspaces, setWorkspaces } = useStoreWorkspaces();

  const shouldFetch = !!isVerified;

  const query = useSmartQuery(["get_workspaces"], () => getWorkspaces(), {
    condition: shouldFetch, // ✅ No need to return early
    zustandSetter: setWorkspaces,
  });

  return {
    membershipRequests,
    pendingInvitations,
    workspaces,
    ...query,
  };
};
